import React, { forwardRef } from "react"
import { GroupProps, HorizontalGroup, VerticalGroup } from "../groups"

export const HorizontalContainer = forwardRef<HTMLDivElement, GroupProps>((props, ref) => {
	const { style, ...rest } = props

	return (
		<HorizontalGroup
			{...rest}
			style={{
				pointerEvents: "all",
				backgroundColor: "rgba(255, 255, 255, 0.8)",
				boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
				backdropFilter: "blur(5px)",
				borderRadius: "10px",
				padding: "10px 12px 10px 12px",
				zIndex: 1,
				...style,
			}}
			ref={ref}
		/>
	)
})

export const VerticalContainer = forwardRef<HTMLDivElement, GroupProps>((props, ref) => {
	const { style, ...rest } = props

	return (
		<VerticalGroup
			{...rest}
			style={{
				pointerEvents: "all",
				backgroundColor: "rgba(255, 255, 255, 0.8)",
				boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
				backdropFilter: "blur(5px)",
				borderRadius: "10px",
				padding: "10px 12px 10px 12px",
				zIndex: 1,
				...style,
			}}
			ref={ref}
		/>
	)
})
